// ============================================
// CONFIGURATION PAIEMENT
// ============================================
// 
// Modifie les valeurs ci-dessous avec tes propres infos !
// ============================================

// URL de base des Cloud Functions Firebase
// En développement : http://localhost:5001/reservation-lasertag/europe-west1
// En production : https://europe-west1-reservation-lasertag.cloudfunctions.net
export const FUNCTIONS_BASE_URL = 
  process.env.NODE_ENV === 'production'
    ? 'https://europe-west1-reservation-lasertag.cloudfunctions.net'
    : 'http://localhost:5001/reservation-lasertag/europe-west1';

// Modes de paiement disponibles
export const PAYMENT_METHODS = {
  STRIPE: 'stripe',                // Paiement intégral en ligne
  STRIPE_DEPOSIT: 'stripe_deposit',// Acompte CB + solde sur place (NOUVEAU)
  ON_SITE: 'on_site',
  BANK_TRANSFER: 'bank_transfer'
};

// Labels pour l'affichage
export const PAYMENT_LABELS = {
  [PAYMENT_METHODS.STRIPE]: 'Carte bancaire (en ligne, 100%)',
  [PAYMENT_METHODS.STRIPE_DEPOSIT]: 'Acompte CB + solde sur place',
  [PAYMENT_METHODS.ON_SITE]: 'Sur place (espèces ou CB)',
  [PAYMENT_METHODS.BANK_TRANSFER]: 'Virement bancaire'
};

// Informations pour le virement bancaire
// ⚠️ MODIFIE CES VALEURS avec tes propres coordonnées bancaires !
export const BANK_INFO = {
  titulaire: 'Centre Équestre Agon-Coutainville',
  iban: 'FR76 XXXX XXXX XXXX XXXX XXXX XXX',
  bic: 'XXXXXXXX',
  banque: 'Ta Banque',
  reference: 'LASERBAY-' // sera suivi du numéro de réservation
};

// Créer une session de paiement Stripe
// IMPORTANT : amountToPay = ce que le client paie maintenant (acompte ou total)
//             totalPrice = le total complet (utile pour info dans la description)
export async function createStripeCheckout(bookingData) {
  try {
    const response = await fetch(`${FUNCTIONS_BASE_URL}/createCheckoutSession`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        bookingId: bookingData.id,
        formulaName: bookingData.formulaName,
        // Montant effectivement débité par Stripe
        amountToPay: bookingData.amountToPay !== undefined 
          ? bookingData.amountToPay 
          : bookingData.totalPrice,
        // Total de la réservation (info)
        totalPrice: bookingData.totalPrice,
        // Type de paiement : 'full' (intégral) ou 'deposit' (acompte)
        paymentType: bookingData.paymentType || 'full',
        contactName: bookingData.contactName,
        contactEmail: bookingData.contactEmail,
        nbParticipants: bookingData.nbParticipants,
        date: bookingData.date,
        startTime: bookingData.startTime,
        // Champs carte cadeau
        isGiftCard: bookingData.isGiftCard,
        giftCode: bookingData.giftCode
      })
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Erreur lors de la création du paiement');
    }

    const data = await response.json();
    return data; // { sessionId, url }
  } catch (error) {
    console.error('Erreur Stripe Checkout:', error);
    throw error;
  }
}

// Vérifier le statut d'un paiement
export async function checkPaymentStatus(sessionId) {
  try {
    const response = await fetch(
      `${FUNCTIONS_BASE_URL}/checkPaymentStatus?sessionId=${sessionId}`
    );
    
    if (!response.ok) {
      throw new Error('Erreur lors de la vérification du paiement');
    }

    return await response.json();
  } catch (error) {
    console.error('Erreur vérification paiement:', error);
    throw error;
  }
}
